"use client";

import {
  useAutumnBase
} from "./chunk-CQ27LXPH.mjs";
import {
  AutumnContext
} from "./chunk-EOSHPHLH.mjs";

// src/libraries/react/hooks/useAutumn.tsx
var useAutumn = () => {
  return useAutumnBase({ AutumnContext });
};

export {
  useAutumn
};
